/**
 * @author Ariel
 * @date 2021-12-30
 * @desc 短视频消息列表页配置
 */
import React from 'react'

let componentName = 'shortVideoMessage'

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '消息接收人',
    name: 'fullName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '帐号',
    name: 'userName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '通知类型',
    name: 'type',
    searchItem: {
      type: 'select'
    },
    tableItem: {},
    dict: [
      {code: 'Follow', codeName: '关注'},
      {code: 'Comment', codeName: '评论'},
      {code: 'At', codeName: '@我'},
      {code: 'Praise', codeName: '点赞'},
      {code: 'Collect', codeName: '收藏'},
    ]
  },
  {
    title: '通知内容',
    name: 'title',
    tableItem: {
      render: (text, record) => {
        let val = "";
        if (record.senderFullName) {
          val = record.senderFullName + record.title;
        }
        return val;
      },
    }
  },
  {
    title: '通知时间',
    name: 'msgTime',
    tableItem: {}
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: [],
      rowOperateView: [],
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
